import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import AutoComplete from  'material-ui/AutoComplete';
function getMenu(employees) {
  let menu = Object.assign([], employees);
  menu.sort((a, b)=> {
    return (parseInt(a.employeeCode) - parseInt(b.employeeCode))

  });
  menu = menu.map((node)=> {
    return node.employeeCode + " " + node.name;
  });
  return menu;
}
class SelectEmployee extends React.Component {

    constructor() {
        super();
      this.state=({selected: null,error: null})
    }

    render() {
      let menu = getMenu(this.props.activeEmployees);

        return (
          <div>

            <AutoComplete
              errorText={this.state.error}
              onNewRequest={(chosenRequest, index)=> {
                if (index == -1) {
                  return;
                }
                console.log(chosenRequest);
                let selected = chosenRequest.split(' ')[0];
                this.setState({selected: selected, error: ""});
                this.props.select(selected);
              }}
              onBlur={(e)=> {
                if (e.target.value.length == 0 || e.target.value == " ") {

                  this.props.unSelect(false);
                }
              }}
              floatingLabelText="Select Employee"
              autoOk={true}
              filter={AutoComplete.caseInsensitiveFilter}
              textFieldStyle={{width: '100%'}}
              defaultValue={""} // DatePicker requires an object,
              // and redux-form defaults to ''
              dataSource={menu}
              maxSearchResults={20}
              />


          </div>
        );
    }

}

SelectEmployee.propTypes = {};


export default SelectEmployee;




/** WEBPACK FOOTER **
 ** ./src/components/common/forms/SelectEmployee.js
 **/